export default __webpack_public_path__ + "static/media/collapse-arrow-left.b36bb62f.svg";